module.exports = __webpack_public_path__ + "static/media/mdwa.c8dbaea5.svg";